import "./App.css";
import MainLayout from "./layout/MainLayout";
import axios from "axios";
import { Link } from "react-router-dom";
import { useEffect } from "react";


function App() {
  // Force Axios to include cookies on every single request
  axios.defaults.withCredentials = true;
  axios.defaults.baseURL = '/';



  return (
    <MainLayout>
      <div>
        <div className="column-container">
          <div className="column">
            <div className="Text-content"><h1>Welcome to RedSaysBlueSays.com</h1></div>
            <div className="Text-content"><h3>Many Perspectives. One Conversation.</h3></div>
            <br />
            <div className="Text-content">Politics doesn't have to be a shouting match.</div>
            <br />

            <div className="Text-content">RedSaysBlueSays is a place to explore political ideas, challenge assumptions, and have honest conversations about the issues that shape our country. We believe people can strongly disagree about politics without treating each other as enemies. Our goal isn't to create another free-for-all forum where the loudest voice wins. It's to create a place where different perspectives can be heard, questioned, and discussed with civility.</div>
            <br />
            <div className="Text-content">To help get the conversation started, RedSaysBlueSays uses artificial intelligence to generate two different perspectives on executive orders, legislation, and political candidates. These analyses are produced by separate AI systems and are instructed to approach each subject from the perspective of <b><i>traditional American liberal or conservative political thought</i></b>.</div>
            <br />
            <div className="Text-content">That distinction is important. The opinions you see here are <b>not the official positions of the Democratic or Republican parties</b>, nor are they necessarily the opinions of any individual politician or the people who operate RedSaysBlueSays. They are starting points—a way of presenting the arguments and assumptions that have traditionally been associated with each side of the political spectrum.</div>
            <br />
            <div className="Text-content">And traditional political labels don't always tell the whole story.</div>
            <br />
            <div className="Text-content">Sometimes a Democratic administration takes a position that conflicts with traditional liberal thinking. Sometimes a Republican candidate supports a policy that doesn't fit neatly within traditional conservative principles. Political parties, candidates, and ideologies evolve, and individual politicians don't always follow the playbook.</div>
            <br />
            <div className="Text-content"><b>That's where the conversation gets interesting.</b></div>
            <br />
            <div className="Text-content">When there is a meaningful difference between traditional party ideology and the actual position of a candidate or executive order, we'll point it out and provide additional information for you to consider.</div>
            <br />
            <div className="Text-content">**[LINK: Example of where the candidate/party position differs from traditional conservative/liberal principles]**</div>
            <br />
            <div className="Text-content">**[LINK: Additional source or explanation of the ideological difference]**</div>
            <br />
            <div className="Text-content">The AI-generated perspectives aren't intended to tell you what to think. They're intended to give you something to think about.</div>
            <br />
            <div className="Text-content">Read both sides. Question both sides. Agree with parts of one and parts of the other. Challenge the assumptions. Bring your own perspective to the discussion.</div>
            <br />
            <div className="Text-content">Most importantly, <b>disagree without being disagreeable.</b></div>
            <br />
            <div className="Text-content">RedSaysBlueSays is built on the idea that political disagreement is not a problem to be eliminated. It is a part of democracy to be understood—and, when possible, a conversation to be shared.</div>
            <br />
            <div className="Text-content"><b>Welcome to the conversation.</b></div>
            <br />
          </div>
          <div className="column">
            <br /><br /><br /><br /><br />
            <div className="Text-content"><h3>Here's a list of our current collections. More will be added as we have the time to do so.</h3></div>
            <br /><br /><br />
            <div className="content-card noborder">
              <div className="content-image-small">
                <img alt="Executive Orders" src={"/graphics/ExecutiveOrders.png"} />
              </div>
              <div className="content-details">
                <div className="content-name">
                  <Link to={"/ExecutiveOrders.html"}>
                    Executive Orders
                  </Link>
                </div>
              </div>
            </div>
            <div className="content-card noborder">
              <div className="content-image-small">
                <img alt="Senate Races" src={"/graphics/SenateRaces.png"} />
              </div>
              <div className="content-details">
                <div className="content-name">
                  <Link to={"/Senate2026.html"}>
                    2026 U.S. Senate Races
                  </Link>
                </div>
              </div>
            </div>
            <div className="content-card noborder">
              <div className="content-image-small">
                <img alt="House Races" src={"/graphics/HouseRaces.png"} />
              </div>
              <div className="content-details">
                <div className="content-name">
                  <Link to={"/House2026.html"}>
                    2026 U.S. House Races
                  </Link>
                </div>
              </div>
            </div>
            <div className="content-card noborder disabled">
              <div className="content-image-small">
                <img alt="Senate Bills" src={"/graphics/SenateBills.png"} />
              </div>
              <div className="content-details">
                <div className="content-name">
                  <Link to={"/SenateBills.html"}>
                    U.S. Senate Bills
                  </Link>
                </div>
              </div>
            </div>
            <div className="content-card noborder disabled">
              <div className="content-image-small">
                <img alt="House Bills" src={"/graphics/HouseBills.png"} />
              </div>
              <div className="content-details">
                <div className="content-name">
                  <Link to={"/HouseBills.html"}>
                    U.S. House Bills
                  </Link>
                </div>
              </div>
            </div>
          </div >
        </div >
        <br />

      </div >
    </MainLayout >
  );
}

export default App;
